// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__uxS1E","Content":"Layout_Content__bj2No"};